import { message } from '@didi-pebble/pebble-design-react';
import { i18nTranslate } from '@didi/i18n-plugin';

const downloadSuccess = (props: any) => {
  const { email } = props;

  return message.success(
    <div
      style={{
        display: 'inline-block',
        verticalAlign: 'top',
        textAlign: 'left',
        maxWidth: 326
      }}
    >
      <p>{i18nTranslate('Internal_Tools_B_kMWu_eiOM')}</p>
      <p>{i18nTranslate('Internal_Tools_B_lKPj_Cfrr', { email_address: email })}</p>
    </div>
  );
};

export default downloadSuccess;
